
<div class="row card-deck">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">

    <div class="card-header wh-header border-bottom">
      Edit Category
      <button type="button" class="close" data-dismiss="modal"
              (click)="activeModal.dismiss('Cross click')"
              aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
      <div class="modal-body overflow-x">

        <section id="form-action-layouts">


          <div class="row justify-content-md-center">
            <div class="col-md-12 padding-left-0px">
              <div class="card">

                <div class="card-body">
                  <div class="px-6">



                    <div class="form-body">
                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px">
                              <label for="firstName"> Name </label>
                            </div>
                            <div class="col-md-5 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px">
                              <label for="firstName">Short Name </label>
                            </div>
                            <div class="col-md-5 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px">
                              <label for="firstName">Parent Category Name </label>
                            </div>
                            <div class="col-md-5 padding-left-0px">

                              <CodeTypeValue CodeType="MARTL"></CodeTypeValue>

                            </div>

                          </div>

                        </div>
                      </div>
                    </div>










                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>


      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime margin-right-auto">Save</button>

      </div>

    </form>
  </div>
</div>

